var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppHeaderDropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"header"},[_c('i',{staticClass:"icon-bell"})]),_c('div',{staticStyle:{"width":"fit-content"}},[_c('template',{slot:"dropdown"},[_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-envelope-o"}),_vm._v(" No hay notificaciones\n    ")])],1)],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }